import React from 'react';
import ErpDocPage from '../components/ErpDocPage';
import ErpTablePage from '../components/ErpTablePage';
const DebitNotes = () => {
  return <ErpDocPage moduleKey="debit_notes" />;
};

export default DebitNotes;